import { DashboardResponse } from "@practium/features/api";
import {
    consultantActivityLineData,
    consultantAnalysisTypeDonutData,
    consultantFarmersChartData,
    consultantRecommendationsChartData,
    consultantTopFarmersData,
} from "./consultantCharts.config";
import {
    companyAnalysisChartData,
    companyConsultantActivityData,
    companyPropertiesData,
    companyRecommendationsChartData,
    companyTeamDonutData,
} from "./companyCharts.config";
import { farmerAnalysisChartData, farmerAnalysisTypeDonutData, farmerProductivityLineData, farmerPropertiesData, farmerRecommendationsChartData } from "./farmerCharts.config";

const getMetricValue = (item: Record<string, unknown>) => {
    const value = item.value ?? item.area ?? item.totalArea ?? item.hectares;

    return typeof value === 'string' || typeof value === 'number'
        ? value
        : undefined;
};

export const getConsultantChartsData = (data?: DashboardResponse) => {
    const monthlyChartData =
        data?.monthlyChart?.data.map((item) => ({
            month: item.month,
            realizado: item.realized,
            anoAnterior: item.realizedLastYear,
        })) ?? consultantFarmersChartData;

    const topFarmersData =
        data?.lists?.[0]?.items.map((item) => ({
            id: item.id,
            name: item.name,
            value: `${item.analyses} análises`,
        })) ?? consultantTopFarmersData;

    const doughnutData =
        data?.doughnutCharts?.[0]?.items.map((item) => ({
            name: item.label,
            value: item.value,
            percent: item.percent,
        })) ?? consultantAnalysisTypeDonutData;

    const pieData =
        data?.doughnutCharts?.[1]?.items.map((item) => ({
            name: item.label,
            value: item.value,
            percent: item.percent,
        })) ?? consultantRecommendationsChartData;


    const lineChartData =
        data?.lineCharts?.[0]?.data.map((item) => ({
            day: item.label,
            current: item.current,
            previous: item.previous,
        })) ?? consultantActivityLineData;

    return {
        monthlyChartData,
        topFarmersData,
        doughnutData,
        pieData,
        lineChartData,
    };
};

export const getFarmerChartsData = (data?: DashboardResponse) => {
    const monthlyChartData =
        data?.monthlyChart?.data.map((item) => ({
            month: item.month,
            realizado: item.realized,
            anoAnterior: item.realizedLastYear,
        })) ?? farmerAnalysisChartData;

    const analysisTypeData =
        data?.doughnutCharts?.[0]?.items.map((item) => ({
            name: item.label,
            value: item.value,
            percent: item.percent,
        })) ?? farmerAnalysisTypeDonutData;

    const recommendationsData =
        data?.doughnutCharts?.[1]?.items.map((item) => ({
            name: item.label,
            value: item.value,
            percent: item.percent,
        })) ?? farmerRecommendationsChartData;

    const propertiesData =
        data?.lists?.[0]?.items.map((item) => ({
            id: item.id,
            name: item.name,
            value: item.analyses,
        })) ?? farmerPropertiesData;

    const analysisData =
        [
            {
                id: 1,
                name: "Análise de Solo Fazenda Boa Vista"
            },
            {
                id: 2,
                name: "Análise de Solo Fazenda Boa Esperança"
            },
            {
                id: 3,
                name: "Análise Foliar Fazenda Boa Vista"
            }


        ]

    const lineChartData =
        data?.lineCharts?.[0]?.data.map((item) => ({
            day: item.label,
            current: item.current,
            previous: item.previous,
        })) ?? farmerProductivityLineData;

    return {
        monthlyChartData,
        analysisTypeData,
        recommendationsData,
        propertiesData,
        analysisData,
        lineChartData,
    };
};

export const getCompanyChartsData = (data?: DashboardResponse) => {
    const companyData = data?.dashboardType === 'company' ? data : undefined;

    const monthlyChartData =
        companyData?.monthlyChart?.data.map((item) => ({
            month: item.month,
            realizado: item.realized,
            planejado: item.realizedLastYear,
        })) ?? companyAnalysisChartData;

    const teamData =
        companyData?.doughnutCharts?.[0]?.items.map((item) => ({
            name: item.label,
            value: item.value,
            percent: item.percent,
        })) ?? companyTeamDonutData;

    const recommendationsData =
        companyData?.doughnutCharts?.[1]?.items.map((item) => ({
            name: item.label,
            value: item.value,
            percent: item.percent,
        })) ?? companyRecommendationsChartData;

    const propertiesData =
        companyData?.lists?.[0]?.items.map((item) => ({
            id: item.id,
            name: item.name,
            value: getMetricValue(item),
        })) ?? companyPropertiesData;

    const lineChartData =
        companyData?.lineCharts?.[0]?.data.map((item) => ({
            day: item.label,
            current: item.current,
            previous: item.previous,
        })) ?? companyConsultantActivityData;

    return {
        monthlyChartData,
        teamData,
        recommendationsData,
        propertiesData,
        lineChartData,
    };
};
